// frontend/shared/components/ErrorBoundary.tsx
import React from 'react';
import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';
import { useTheme } from '@/components/common/ThemeProvider';
import {ExceptionStatusType} from "antd/es/result";

export const ErrorBoundary: React.FC = () => {
    const error = useRouteError();
    const navigate = useNavigate();
    const { dark } = useTheme();

    if (isRouteErrorResponse(error)) {
        console.log(error)
        return (
            <Result
                status={error.status as ExceptionStatusType || '404'}
                title={error.status === 404 ? '404 - Not Found' : 'Error'}
                subTitle={error.statusText || error.data?.message || 'Sorry, something went wrong.'}
                className={dark ? 'dark' : ''}
                extra={
                    <div className="space-x-4">
                        <Button type="primary" onClick={() => navigate('/')}>
                            Go Home
                        </Button>
                        <Button onClick={() => navigate(-1)}>
                            Go Back
                        </Button>
                    </div>
                }
            />
        );
    }

    return (
        <Result
            status="error"
            title="Unexpected Error"
            subTitle={error instanceof Error ? error.message : 'An unexpected error occurred'}
            className={dark ? 'dark' : ''}
            extra={
                <div className="space-x-4">
                    <Button type="primary" onClick={() => navigate('/')}>
                        Go Home
                    </Button>
                    <Button onClick={() => navigate(-1)}>
                        Go Back
                    </Button>
                </div>
            }
        />
    );
};